import { Module, Context } from 'vuex-smart-module';
import { CoreState } from '@/store/core/state';
import { CoreGetters } from '@/store/core/getters';
import { CoreMutations } from '@/store/core/mutations';
import { CoreActions } from '@/store/core/actions';

export const coreModule = new Module({
	state: CoreState,
	getters: CoreGetters,
	mutations: CoreMutations,
	actions: CoreActions,
});

export type CoreModuleContext = Context<Module<CoreState, CoreGetters, CoreMutations, CoreActions>>;
